var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLevelAdvanced(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_13_1",
    "data-name": "Component 13 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.868,
    height: 23.71,
    viewBox: "0 0 21.868 23.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M474.52,63.646h-3.627c-.654,0-1.187-.363-1.187-.81v-22c0-.447.532-.81,1.187-.81h3.627c.654,0,1.187.363,1.187.81v22C475.7,63.286,475.175,63.646,474.52,63.646Z",
    transform: "translate(-453.839 -40.028)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M309.367,217.866H305.3c-.533,0-.967-.305-.967-.679V202.363c0-.374.434-.679.967-.679h4.066c.533,0,.967.3.967.679v14.823C310.334,217.561,309.9,217.866,309.367,217.866Z",
    transform: "translate(-296.544 -194.194)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M150.113,335.8h-4.485c-.418,0-.757-.238-.757-.532v-8.859c0-.294.339-.532.757-.532h4.485c.418,0,.757.238.757.532v8.862c0,.291-.339.53-.757.53Z",
    transform: "translate(-144.87 -312.094)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevelAdvanced);
export default __webpack_public_path__ + "static/media/Level_advanced.d819a1cc6b5ca49c85021d31cf4f855d.svg";
export { ForwardRef as ReactComponent };